import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Import i18n (must be before App)
import '@nohara-dxdev/react-core';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import './index.css';

import { App } from './app';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
